import React, { useEffect } from 'react';
import { useIntl, history } from 'umi';
import { useRequest } from 'ahooks';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import GameList from './components/GameList';
import { getCompanyDetailsPath } from '@/pages/intelligence/utils/topchartsUtils';
import { COMBINEID_REG } from '@intelligence/utils/constant';
import { fetchCompanyDetailsSummaryGames } from '@/pages/intelligence/services/companies';
import type { IGameType } from '@/pages/intelligence/types/common';
import type { ICompaniesDetailsPageBaseProps } from '../../../types';
import type { IGameData } from './types';

import './index.scss';

const Games: React.FC<ICompaniesDetailsPageBaseProps> = (props) => {
  const { companyId } = props;

  const { formatMessage } = useIntl();

  const { loading, data, run } = useRequest(fetchCompanyDetailsSummaryGames, { manual: true });

  const mobileNum = Number.parseInt(data?.mobile_num, 10) || 0;
  const pcNum = Number.parseInt(data?.pc_num, 10) || 0;
  const consoleNum = Number.parseInt(data?.console_num, 10) || 0;
  const gamesNums: {
    [key in IGameType]: number;
  } = {
    mobile: mobileNum,
    pc: pcNum,
    console: consoleNum,
  };
  const gamesDates: {
    [key in IGameType]: string;
  } = {
    mobile: data?.stat_time,
    pc: data?.pc_stat_time,
    console: data?.console_stat_time,
  };
  const gamesTypes: { entity_type: IGameType; game_info_list: IGameData[] }[] =
    data?.game_item_list ?? [];

  const isNoData = !gamesTypes || (mobileNum === 0 && pcNum === 0 && consoleNum === 0);

  const goToGamesStats = () => {
    const path = getCompanyDetailsPath({ companyId, tab: 'GamesStats', segment: 'gamesOwned' });
    history.push(path);
  };

  useEffect(() => {
    if (!companyId) return;
    if (!COMBINEID_REG.test(companyId)) return; // 添加ID校验规则
    run({ company_id: companyId });
  }, [companyId]);

  return (
    <CardSlot
      title={formatMessage({ id: 'dbi_games' })}
      isAction={true}
      iconList={[]}
      getDetails={goToGamesStats}
    >
      <Abnormal
        isLoading={loading}
        isNoData={isNoData}
        component={
          <>
            {gamesTypes?.map((gameType: any, idx: number) => (
              <GameList
                key={idx}
                entityType={gameType?.entity_type}
                gamesTotal={gamesNums[gameType?.entity_type]}
                gamesDate={gamesDates[gameType?.entity_type]}
                games={gameType?.game_info_list}
              />
            ))}
          </>
        }
      />
    </CardSlot>
  );
};

export default Games;
